import { cn } from "@/shared/helpers/cn.helper";

export const TableHeader: React.FC<React.ComponentProps<"thead">> = ({
  className,
  ...props
}) => {
  return (
    <thead
      className={cn("text-btn-primary", className)}
      data-slot="table-header"
      {...props}
    />
  );
};
